<template>
    <div>
        <div
            hreflang="en-ca"
            :to="uri"
            class="text-decoration-none"
            aria-label="Book a demo"
        >
            <BoxGradient
                class="w-full"
                style="min-height: 280px"
                :icon="icon"
                :btn-text="btnText"
                :is-primary="false"
                :uri="uri"
            >
                <template #content>
                    <slot name="content" />
                </template>
            </BoxGradient>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Find out how peekage can exceed your business goals',
        },
        uri: {
            type: String,
            default: '/contact?talk-to-an-expert=true',
        },
        btnText: {
            type: String,
            default: 'Book a demo',
        },
        icon: {
            type: String,
            default: 'arrow-right',
        },
    },
};
</script>

